import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Heart, Users, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';

const EqualityDiversity = () => {
  const protectedCharacteristics = [
    'Age',
    'Disability',
    'Gender reassignment',
    'Marriage or civil partnership',
    'Pregnancy or maternity',
    'Race',
    'Religion or belief',
    'Sex',
    'Sexual orientation'
  ];

  const aims = [
    {
      icon: Heart,
      title: 'Culturally Sensitive Care',
      description: 'Deliver culturally sensitive, person-centred care to all individuals'
    },
    {
      icon: Users,
      title: 'Reasonable Adjustments',
      description: 'Make reasonable adjustments to meet individual needs'
    },
    {
      icon: CheckCircle,
      title: 'Equal Opportunities',
      description: 'Promote equality of opportunity for staff and service users'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#E8F4FC] to-[#F0EDF7] py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <Globe className="w-16 h-16 text-[#4A90E2] mx-auto" />
            <h1 className="heading-hero">Equality, Diversity & Inclusion</h1>
            <p className="body-large">
              Committed to equality, diversity, and inclusion in all aspects of service delivery and employment.
            </p>
          </div>
        </div>
      </section>

      {/* Main Commitment */}
      <section className="section bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <p className="body-large text-center mb-8">
              Three Spheres Healthcare is committed to equality, diversity, and inclusion in all aspects of service delivery and employment.
            </p>
            <Card className="p-8 border-0 bg-[#E8F4FC] mb-12">
              <p className="body-medium text-center text-gray-800">
                We do not tolerate discrimination on the basis of any protected characteristic.
              </p>
            </Card>

            {/* Protected Characteristics */}
            <h2 className="heading-2 mb-8 text-center">Protected Characteristics</h2>
            <div className="grid md:grid-cols-3 gap-4 mb-12">
              {protectedCharacteristics.map((characteristic, index) => (
                <Card key={index} className="p-4 border-0 bg-gray-50 text-center">
                  <p className="font-medium text-gray-800">{characteristic}</p>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Our Aims */}
      <section className="section bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="heading-2 mb-12 text-center">We Aim To</h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {aims.map((aim, index) => {
              const Icon = aim.icon;
              return (
                <Card key={index} className="p-8 border-0 text-center hover:shadow-lg transition-all">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#4A90E2] to-[#7B68BE] rounded-xl flex items-center justify-center mx-auto mb-6">
                    <Icon className="text-white" size={28} />
                  </div>
                  <h3 className="heading-3 mb-4">{aim.title}</h3>
                  <p className="text-sm text-gray-600">{aim.description}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Closing Statement */}
      <section className="section bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-[#E8F4FC] to-[#F0EDF7] rounded-2xl p-8 md:p-12 text-center">
              <Globe className="w-12 h-12 text-[#4A90E2] mx-auto mb-6" />
              <p className="body-large text-gray-800">
                We respect and value diversity and strive to create inclusive environments where people feel safe, heard, and respected.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section bg-gradient-to-r from-[#4A90E2] to-[#7B68BE] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="heading-2 text-white">Questions About Our Approach?</h2>
            <p className="body-large text-white/90">
              Contact us for more information about our equality, diversity, and inclusion policies.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-[#4A90E2] hover:bg-gray-100">
                Get in Touch
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EqualityDiversity;
